import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"

export default class extends Controller {
  static values = {
    altFormat: { type: String, default: "M j, Y" },
    dateFormat: { type: String, default: "Y-m-d" },
    enableTime: { type: Boolean, default: false },
    submitOnClose: { type: Boolean, default: false }
  }

  connect() {
    this.changed = false
    this.picker = flatpickr(this.element, {
      allowInput: true,
      altInput: true,
      altInputClass: ["admin-flatpickr-input", this.element.className].filter(Boolean).join(" "),
      altFormat: this.altFormatValue,
      dateFormat: this.dateFormatValue,
      disableMobile: true,
      enableTime: this.enableTimeValue,
      time_24hr: false,
      locale: { firstDayOfWeek: 1 },
      minDate: this.element.min || undefined,
      maxDate: this.element.max || undefined,
      onChange: () => { this.changed = true },
      onClose: () => {
        if (!this.submitOnCloseValue || !this.changed) return

        this.changed = false
        this.element.form?.requestSubmit()
      }
    })
  }

  disconnect() {
    this.picker?.destroy()
  }
}
